import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import type { V2Hero } from './content';

export function Hero({ content }: { content: V2Hero }) {
  return (
    <header className="v2-hero">
      <div className="v2-hero-ambient" aria-hidden="true">
        <span className="v2-orb v2-orb-a" />
        <span className="v2-orb v2-orb-b" />
        <span className="v2-orb v2-orb-c" />
      </div>

      <div className="v2-container">
        <div className="v2-hero-top">
          <div className="v2-hero-copy">
            <span className="v2-badge v2-hero-enter" style={{ '--d': '0s' } as CSSProperties}>
              <span className="v2-badge-dot" aria-hidden="true" />
              {content.badge}
            </span>
            <h1 className="v2-hero-title">
              {content.titleLines.map((line, index) => (
                <span className="v2-line" key={line}>
                  <span
                    className={`v2-line-inner ${index === content.accentIndex ? 'v2-serif-accent' : ''}`}
                    style={{ '--d': `${0.12 + index * 0.14}s` } as CSSProperties}
                  >
                    {line}
                  </span>
                </span>
              ))}
            </h1>
          </div>

          <div className="v2-hero-aside v2-hero-enter" style={{ '--d': '0.55s' } as CSSProperties}>
            <p className="v2-hero-body">{content.body}</p>
            <div className="v2-hero-ctas">
              <Link to={content.primaryCta.href} className="v2-btn v2-btn-dark">
                {content.primaryCta.label}
                <i className="ph ph-arrow-right" aria-hidden="true" />
              </Link>
              <Link to={content.secondaryCta.href} className="v2-btn v2-btn-ghost">
                {content.secondaryCta.label}
              </Link>
            </div>
            <ul className="v2-hero-proof">
              {content.microProof.map((point) => (
                <li key={point}>
                  <i className="ph ph-check" aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="v2-hero-stage" data-parallax-scope>
          <div className="v2-hero-frame v2-hero-frame-enter">
            <div className="v2-frame-chrome" aria-hidden="true">
              <span className="v2-frame-dots">
                <i />
                <i />
                <i />
              </span>
              <span className="v2-frame-url">app.elen1.com</span>
            </div>
            <img src={content.screenImage} alt={content.screenAlt} loading="eager" />
          </div>

          <div className="v2-float v2-float-booking" data-parallax="0.16">
            <div className="v2-float-inner">
              <span className="v2-float-label">
                <i className="ph ph-calendar-check" aria-hidden="true" />
                {content.floatCards.booking.label}
              </span>
              <strong>{content.floatCards.booking.title}</strong>
              <small>{content.floatCards.booking.meta}</small>
            </div>
          </div>

          <div className="v2-float v2-float-revenue" data-parallax="-0.12">
            <div className="v2-float-inner">
              <span className="v2-float-label">
                <i className="ph ph-trend-up" aria-hidden="true" />
                {content.floatCards.revenue.label}
              </span>
              <strong className="v2-float-value">{content.floatCards.revenue.value}</strong>
              <small>{content.floatCards.revenue.meta}</small>
            </div>
          </div>

          <div className="v2-float v2-float-scribe" data-parallax="0.1">
            <div className="v2-float-inner">
              <span className="v2-float-label">
                <i className="ph ph-sparkle" aria-hidden="true" />
                {content.floatCards.scribe.label}
              </span>
              <small>{content.floatCards.scribe.body}</small>
              <span className="v2-eq" aria-hidden="true">
                <i />
                <i />
                <i />
                <i />
                <i />
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
